import React, { Component } from "react";
import {
  Wrapper,
  Card,
  Title,
  Copy,
  Bold,
  Row,
  Button,
  Icon,
  ModalOverlay,
  Modal,
  SecondaryButton,
  DeleteButton,
  CardBody
} from "app/NativeComponents/common";

import { TextButton } from "app/NativeComponents/snippets";

class PhoneNumberGroupItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show_phone_more: false
    };
  }

  renderMore() {
    if (this.state.show_phone_more) {
      return (
        <ModalOverlay
          isVisible={true}
          onPress={() => {
            this.setState({
              show_phone_more: false
            });
          }}
        >
          <Modal actionSheet>
            <Card
              style={{
                minWidth: "95%",
                paddingBottom: this.props.device == "mobile" ? 10 : 0
              }}
            >
              <CardBody>
                <Title style={{ textAlign: "center" }}>
                  Phone Number Group Options
                </Title>
                <Copy style={{ textAlign: "center" }}>Select an option</Copy>
              </CardBody>
              {/*
              <Card style={{ borderRadius: 30, overflow: "hidden" }}>
                <SecondaryButton
                  onPress={() => {
                    this.props.updateTeamPhoneNumber({
                      token: this.props.token,
                      type: "messaging_profile_id",
                      team_phone_number_group_id: this.props.phone_number_group
                        .id
                    });
                    this.setState({
                      show_phone_more: false
                    });
                  }}
                >
                  Activate All Phone Numbers
                </SecondaryButton>
              </Card>
              */}
              <Card style={{ borderRadius: 30, overflow: "hidden" }}>
                <SecondaryButton
                  onPress={() => {
                    this.props.updateTeamPhoneNumber({
                      token: this.props.token,
                      type: "update_number",
                      team_phone_number_group_id: this.props.phone_number_group
                        .id,
                      default_number: 1,
                      phone_label: ""
                    });
                    this.setState({
                      show_phone_more: false
                    });
                  }}
                >
                  Make Default Number
                </SecondaryButton>
              </Card>

              <Card style={{ borderRadius: 30, overflow: "hidden" }}>
                <SecondaryButton
                  onPress={() => {
                    this.props.setEditModal({
                      title: "Edit Forwarding Number",
                      description:
                        "Edit the forwarding phone number for this number block. This will redirect phone calls made to all phone numbers in this block.",
                      slug: "edit-forwarding-number",
                      type: "edit_forwarding_number",
                      fields: {
                        forwarding_number: this.props.phone_number_group
                          .forwarding_number
                      },
                      save_button_text: "Save Forwarding Number",
                      modalAction: ({ fields }) => {
                        this.props.updateTeamPhoneNumber({
                          token: this.props.token,
                          type: "forwarding_number",
                          team_phone_number_group_id: this.props
                            .phone_number_group.id,
                          forwarding_number: fields.forwarding_number
                        });
                      }
                    });
                    this.props.appRedirect({
                      redirect: "goForward",
                      payload: { add: "edit-forwarding-number" }
                    });

                    this.setState({
                      show_phone_more: false
                    });
                  }}
                >
                  Edit Forwarding Number
                </SecondaryButton>
              </Card>

              <Card style={{ borderRadius: 30, overflow: "hidden" }}>
                <DeleteButton
                  onPress={() => {
                    this.props.setModal({
                      title: "Delete Phone Number Group",
                      description:
                        "Are you sure you want to delete this phone number group? You will no longer recieve SMS messages from these numbers.",
                      icon: "delete",
                      submit: "Delete Phone Number Group",
                      buttonType: "destroy",
                      onPress: () => {
                        this.props.updateTeamPhoneNumber({
                          token: this.props.token,
                          type: "remove_number",
                          team_phone_number_group_id: this.props
                            .phone_number_group.id
                        });
                      },
                      cancel: "Cancel",
                      onCancel: () => {}
                    });
                    this.props.toggleModal({ show: true, type: "normal" });
                    this.setState({
                      show_phone_more: false
                    });
                  }}
                >
                  Delete Phone Number Group
                </DeleteButton>
              </Card>

              <TextButton
                onPress={() => {
                  this.setState({
                    show_phone_more: false
                  });
                }}
                text={"Cancel"}
              />
            </Card>
          </Modal>
        </ModalOverlay>
      );
    }
  }
  renderDefaultNumberLabel() {
    const { colors, phone_number_group } = this.props;

    if (phone_number_group.default_number) {
      return (
        <Wrapper
          style={{
            backgroundColor: colors.background_color,
            borderRadius: 15,
            padding: 3,
            paddingLeft: 10,
            paddingRight: 10,
            marginLeft: 5
          }}
        >
          <Copy>Default Number</Copy>
        </Wrapper>
      );
    }
  }
  render() {
    const { phone_number_group } = this.props;
    if (phone_number_group) {
      return (
        <Wrapper>
          <Card>
            <Row>
              <Wrapper style={{ flex: 1 }}>
                <Wrapper style={{ padding: 20 }}>
                  <Wrapper>
                    <Title>{phone_number_group.phone_number_placeholder}</Title>
                    <Row>
                      <Copy>{phone_number_group.phone_label}</Copy>
                      {this.renderDefaultNumberLabel()}
                    </Row>
                  </Wrapper>
                  <Wrapper style={{ padding: 10 }}>
                    <Wrapper style={{ paddingBottom: 10 }}>
                      <Copy>
                        <Bold>Forward calls to:</Bold>
                      </Copy>
                      <Copy>{phone_number_group.forwarding_number}</Copy>
                    </Wrapper>
                    <Copy>
                      <Bold>Current numbers include:</Bold>
                    </Copy>
                    <Row style={{ flexWrap: "wrap" }}>
                      {phone_number_group.phone_numbers.map(
                        (phone_number, i) => {
                          return (
                            <Wrapper
                              key={"phone_number_" + i}
                              style={{ width: "50%" }}
                            >
                              <Row>
                                <Copy>{phone_number.phone_number}</Copy>
                                {!!phone_number.provider_phone_id ? (
                                  <Icon
                                    color={this.props.colors.success_color}
                                    icon="check-circle"
                                    size={14}
                                    style={{ marginLeft: 5 }}
                                  />
                                ) : null}
                              </Row>
                            </Wrapper>
                          );
                        }
                      )}
                    </Row>
                  </Wrapper>
                </Wrapper>
              </Wrapper>
              <Button
                style={{
                  width: 50,
                  height: 60,
                  alignItems: "center",
                  justifyContent: "center"
                }}
                onPress={() => {
                  this.setState({
                    show_phone_more: true
                  });
                }}
              >
                <Icon size={22} icon="more-vert" />
              </Button>
            </Row>
          </Card>
          {this.renderMore()}
        </Wrapper>
      );
    }
    return <Wrapper />;
  }
}

export default PhoneNumberGroupItem;
